import React from 'react';
import SearchInput, { createFilter } from 'react-search-input';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  ModalHeader,
} from 'reactstrap';

import { FIXED_DUTY_STATE, VALID_RANKS } from '../../../../utils/examConstants';
import CircularLoading from '../../../Common/CircularLoading/CircularLoading';

class ChangeRatingExam extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRate: { id: 0, name: '', isPfeOnly: false },
      selectedPaygrade: '',
      rateSelectorIsOpen: false,
      paygradeSelectorIsOpen: false,
      rateSetted: false,
      rankSetted: false,
      searchTerm: '',
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.user.rate && !this.state.rateSetted) {
      this.setState({ selectedRate: nextProps.user.rate, rateSetted: true });
    }

    if (nextProps.user.rank && !this.state.rankSetted) {
      this.setState({
        selectedPaygrade: nextProps.user.rank,
        rankSetted: true,
      });
    }
  }

  handleRateSelectorClick = () => {
    this.setState({
      rateSelectorIsOpen: !this.state.rateSelectorIsOpen,
      searchTerm: '',
    });
  };

  handlePaygradeSelectorClick = () => {
    this.setState({
      paygradeSelectorIsOpen: !this.state.paygradeSelectorIsOpen,
    });
  };

  handleRateOptionClick = (rate) => {
    this.setState({
      selectedRate: rate,
      selectedPaygrade: '',
    });
  };

  handlePaygradeOptionClick = (pg) => {
    this.setState({ selectedPaygrade: pg });
  };

  searchUpdated = (term) => {
    this.setState({ searchTerm: term });
  };

  renderRateSelector = () => {
    const filteredRates = this.props.rates
      .filter(createFilter(this.state.searchTerm, ['shortname']))
      .sort((a, b) => {
        if (a.shortname < b.shortname) {
          return -1;
        }
        if (a.shortname > b.shortname) {
          return 1;
        }
        return 0;
      });
    return (
      <div className="field">
        <Dropdown
          isOpen={this.state.rateSelectorIsOpen}
          toggle={this.handleRateSelectorClick}
          className="rating-exam-selector"
        >
          <DropdownToggle className="rating-exam-dropdown-toggle">
            {this.state.selectedRate.id !== 0 && (
              <span className="option-title">
                {this.state.selectedRate.shortname}
              </span>
            )}
            {this.state.selectedRate.id === 0 && (
              <span className="option-title option-title-placeholder">
                Select Your AFSC
              </span>
            )}
            {this.state.rateSelectorIsOpen ? (
              <i className="icon-expand select-icon rotate down" />
            ) : (
              <i className="icon-expand select-icon rotate" />
            )}
          </DropdownToggle>

          <DropdownMenu className="rate-menu">
            <SearchInput
              className="search-input rate-filter"
              onChange={this.searchUpdated}
              autoFocus
            />
            {filteredRates.map((rate) => (
              <DropdownItem
                className="drop-item"
                key={rate.id}
                onClick={() => this.handleRateOptionClick(rate)}
              >
                {rate.isPfeOnly === true ? (
                  <div>
                    <span>{rate.shortname}</span>
                    <span className="font-italic"> (PFE Only) </span>
                  </div>
                ) : (
                  <span>{rate.shortname}</span>
                )}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
        <div className="gray-divider" />
      </div>
    );
  };

  renderExamPaygradeSelector = () => {
    const filteredRates = this.props.rates.filter(
      (rate) => rate.id === this.state.selectedRate.id,
    );

    // Check if any valid exam (E5 or E6 Regular) exists for this rate
    const availableRanks = [];

    filteredRates.forEach((rate) => {
      VALID_RANKS.forEach((rank) => {
        const examKey = `${rank.toLowerCase()}_regular`;
        if (rate[examKey] !== undefined && !rate[examKey]) {
          availableRanks.push(rank);
        }
      });
    });

    return (
      <div className="field mb-0">
        <Dropdown
          isOpen={this.state.paygradeSelectorIsOpen}
          toggle={this.handlePaygradeSelectorClick}
          className="rating-exam-selector"
        >
          <DropdownToggle className="rating-exam-dropdown-toggle">
            {this.state.selectedPaygrade !== '' && (
              <span className="option-title">
                {this.state.selectedPaygrade}
              </span>
            )}
            {this.state.selectedPaygrade === '' && (
              <span className="option-title option-title-placeholder">
                Exam Paygrade
              </span>
            )}
            {this.state.paygradeSelectorIsOpen ? (
              <i className="icon-expand select-icon rotate down" />
            ) : (
              <i className="icon-expand select-icon rotate" />
            )}
          </DropdownToggle>
          <DropdownMenu>
            {availableRanks.length === 0 ? (
              <DropdownItem
                className="drop-item"
                key="No Exam Paygrade available for this exam"
                disabled
              >
                No Exam Paygrade available for this exam
              </DropdownItem>
            ) : (
              availableRanks.map((rank) => (
                <DropdownItem
                  key={rank}
                  className="drop-item"
                  onClick={() => this.handlePaygradeOptionClick(rank)}
                >
                  {rank}
                </DropdownItem>
              ))
            )}
          </DropdownMenu>
        </Dropdown>
        <div className="gray-divider" />
      </div>
    );
  };

  render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        className="rating-exam-popup modal-dialog-centered"
        modalClassName={
          !this.props.completeUserInfoStep
            ? 'rating-exam-modal'
            : 'missign-username-popup'
        }
        toggle={this.props.onClose}
      >
        {!this.props.completeUserInfoStep && (
          <>
            <ModalHeader className="rating-exam-modal-header">
              <i className="icon-close" onClick={this.props.onClose} />
              <div className="title">change AFSC exam</div>
            </ModalHeader>
            <div className="gradient-divider" />
          </>
        )}

        {this.props.completeUserInfoStep === 1 && (
          <div className="cancel-popup-header">
            <div className="title">
              <i className="icon-close" onClick={this.props.onClose} />
            </div>
          </div>
        )}

        <ModalBody className="rating-exam-modal-body">
          {!this.props.completeUserInfoStep && (
            <>
              <div className="warning-message">
                {!this.props.user.rate || !this.props.user.rank
                  ? 'Please select your AFSC exam.'
                  : 'Heads up! AFSC exam can be changed only once every 30 days.'}
              </div>
              {this.renderRateSelector()}
              {this.renderExamPaygradeSelector()}
              {this.state.selectedRate &&
                this.state.selectedRate.id !== 0 &&
                this.props.user &&
                this.props.user.rate &&
                this.props.user.rate.id !== this.state.selectedRate.id && (
                  <p className="advertising__message">
                    * Please note that changing your AFSC exam will result in
                    the removal of your favorite questions and submitted
                    questions.
                  </p>
                )}
              <button
                className="btn btn-block change-rating-exam-button btn-danger"
                onClick={() => {
                  this.props.setReviewMode(false);
                  this.props.setPracticeExam(null);
                  this.props.setExamQuestions([]);
                  this.props.setResultsSummarized([]);
                  this.props.setSwitchPfeSkt(this.props.user.pfeRate.id);
                  this.props.onSave(
                    this.props.user.id,
                    this.state.selectedRate,
                    this.state.selectedPaygrade,
                    FIXED_DUTY_STATE, // Always Regular
                    null, // No cycle needed for Regular
                  );
                }}
                disabled={
                  this.state.selectedRate.id === 0 ||
                  this.state.selectedPaygrade === '' ||
                  this.props.waiting ||
                  !this.props.user.id
                }
              >
                {this.props.waiting ? (
                  <CircularLoading className="loading-gif-waiting" />
                ) : (
                  'change AFSC exam'
                )}
              </button>
              {this.props.message.text !== '' &&
                this.props.message.type === 'error' && (
                  <div className={`message-${this.props.message.type}`}>
                    {this.props.message.text}
                  </div>
                )}
            </>
          )}
          {this.props.completeUserInfoStep === 1 && (
            <>
              <div className="cancel-popup-item-row">
                <div className="item-description">
                  We don't have a username for you yet! What would you like to
                  be known as? This will be displayed in the leader board.
                </div>
              </div>
              <button
                className="btn btn-danger pause-subscription-button btn-block"
                onClick={() => this.props.onSave()}
              >
                Set Username
              </button>
            </>
          )}
        </ModalBody>
      </Modal>
    );
  }
}

export default ChangeRatingExam;
